<template>
    <div class="mitarbeiterstatistik-monat-filter">
        <b-form-group label="Monat" :label-cols="11">
            <b-form-select v-model="selectedMonat"
                           :options="monate"
                           :plain="true"
                           @change="updateFilter"
                           style="width:auto"/>
        </b-form-group>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { FormGroupPlugin, FormSelectPlugin } from 'bootstrap-vue'
  import umsatz from '../../api/kpi-energie-api/umsatz'

  Vue.use(FormGroupPlugin)
  Vue.use(FormSelectPlugin)

  export default {
    name: 'MitarbeiterstatistikMonatFilter',
    props: {
      filterMutations: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        monate: null,
        selectedMonat: null
      }
    },
    methods: {
      updateFilter (val) {
        this.filterMutations.remove('Monat')
        if (val !== 'Keine Auswahl') {
          this.filterMutations.add({ Name: 'Monat', Value: val })
        }
        this.filterMutations.update()
      }
    },
    created() {
      umsatz.holeMonate()
        .then(response => {
          this.monate = response.data
          this.selectedMonat = this.monate[0]
        })
    }
  }
</script>

<style scoped>
</style>
